var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.61 33.39C70.73 49.51 79.05 67.33 73.18 73.19C67.32 79.05 49.5 70.74 33.38 54.62C17.27 38.49 8.95 20.67 14.81 14.81C20.67 8.95 38.49 17.26 54.61 33.38V33.39ZM73.19 14.81C62.2 3.82 50.61 -2.42 47.32 0.879999C44.03 4.18 50.26 15.76 61.25 26.75C72.24 37.74 83.82 43.98 87.12 40.68C90.42 37.38 84.18 25.8 73.19 14.81ZM0.879999 47.32C-2.42 50.62 3.82 62.2 14.81 73.19C25.8 84.18 37.38 90.42 40.68 87.12C43.98 83.82 37.74 72.24 26.75 61.25C15.76 50.26 4.18 44.02 0.879999 47.32Z",
    fill: "#6D247A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon_13.efb75343fbaa4ae04631fc1163ed99c6.svg";
export { ForwardRef as ReactComponent };